var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amr-progress"},[_c('img',{staticClass:"thumb",attrs:{"src":_vm.thumb}}),_c('div',{staticClass:"amr-media"},[_c('div',{class:{
            'play-btn': true,
            'playing': _vm.playing
        },on:{"click":_vm.controlRecord}},[_vm._m(0)])]),_c('div',{ref:"amrdom",staticClass:"aplayer"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"la-line-scale-party"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }